<template>
  <div class="maintenance-area">
    <div v-if="isMaintenance">
      <h2 class="mt-3 maintenance-ttl">{{ $t('under_maintenance') }}</h2>
      <p class="mt-3 maintenance-txt">{{ $t('nanacara_for_doctor_is_currently_undergoing_maintenance') }}</p>
      <p class="mt-3 maintenance-txt">{{ $t('maintenance_time') }} {{ startDateTime ? formatDateTime(startDateTime) : ''
        }} 〜 {{ endDateTime ? formatDateTime(endDateTime) : '' }}</p>
    </div>
    <div v-else>
      <h2 class="mt-3 maintenance-ttl">{{ $t('maintenance_completed') }}</h2>
      <p class="mt-3 maintenance-txt">{{ $t('maintenance_for_nanacara_for_doctor_has_ended') }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapState({
      isMaintenance: state => state.maintenance.isMaintenance,
      startDateTime: state => state.maintenance.startDateTime,
      endDateTime: state => state.maintenance.endDateTime
    }),
  },
  async mounted() {
    this.checkStillMaintenance()
    this.startAutoRecheck()
  },
  beforeDestroy() {
    this.stopAutoRecheck()
  },
  methods: {
    formatDateTime(dateTime) {
      return moment(dateTime).format('YYYY/MM/DD HH:mm')
    },
    async checkStillMaintenance() {
      const isMaintenance = await this.$store.dispatch('maintenance/checkStillMaintenance')
      if (!isMaintenance) {
        this.$router.push({ name: 'home' })
      }
    },
    startAutoRecheck() {
      this.autoRecheckInterval = setInterval(() => {
        this.checkStillMaintenance()
      }, 30000) // 30 seconds
    },
    stopAutoRecheck() {
      if (this.autoRecheckInterval) {
        clearInterval(this.autoRecheckInterval)
      }
    },
  }
}
</script>
<style scoped>
.maintenance-area {
  width: 100%;
  margin: 0 auto;
  padding-top: 100px;
  box-sizing: border-box;
  text-align: center;
}

.maintenance-ttl {
  box-sizing: border-box;
  font-size: 1.6rem;
  line-height: 2.0rem;
  color: #ff8ea1;
  padding-bottom: 50px;
  font-weight: bold;
}

.maintenance-txt {
  box-sizing: border-box;
  font-size: 1.2rem;
  line-height: 1.8rem;
  text-align: center;
  padding-bottom: 20px;
}
</style>
